import { useState } from 'react';
import { FiMenu, FiX, FiArrowRight } from 'react-icons/fi';
import Logo from '../img/mina4.jpg';

const Nav = ({ home = '#home', about = '#about', service = '#services', contact = '#contactus' }) => {
  const [open, setOpen] = useState(false);

  const links = [
    { href: about, label: 'About' },
    { href: service, label: 'Services' },
    { href: '#team', label: 'Team' },
    { href: '#portfolio', label: 'Portfolio' },
  ];

  const close = () => setOpen(false);

  return (
    <header className="fixed inset-x-0 top-3 z-50 px-3 sm:top-4 sm:px-5">
      <div className="mx-auto max-w-6xl rounded-[1.75rem] border border-white/10 bg-[#111111] shadow-float">
        <div className="flex h-16 items-center justify-between gap-4 pl-3 pr-2 sm:pl-4">
          <a href={home} onClick={close} aria-label="Mina Technologies home">
            <img src={Logo} alt="Mina Technologies" className="h-10 w-[110px] rounded-lg object-cover" />
          </a>

          <nav className="hidden md:block">
            <ul className="flex items-center gap-8">
              {links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-[0.95rem] font-medium text-white/75 underline-offset-[7px] decoration-brand decoration-2 transition-colors hover:text-white hover:underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="flex items-center gap-2">
            <a href={contact} className="btn-primary hidden h-11 sm:inline-flex">
              Start a project <FiArrowRight />
            </a>
            <button
              type="button"
              className="inline-grid h-11 w-11 place-items-center rounded-full text-white hover:bg-white/10 md:hidden"
              onClick={() => setOpen(!open)}
              aria-label={open ? 'Close menu' : 'Open menu'}
              aria-expanded={open}
            >
              {open ? <FiX size={22} /> : <FiMenu size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <nav className="border-t border-white/10 px-4 pb-4 md:hidden">
            <ul className="flex flex-col py-2">
              {links.map((link) => (
                <li key={link.label}>
                  <a href={link.href} onClick={close} className="block py-3 font-medium text-white/80 hover:text-white">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <a href={contact} onClick={close} className="btn-primary w-full">
              Start a project <FiArrowRight />
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Nav;
